import { render, staticRenderFns } from "./recordCard.vue?vue&type=template&id=16eabd96&scoped=true&"
import script from "./recordCard.vue?vue&type=script&lang=js&"
export * from "./recordCard.vue?vue&type=script&lang=js&"
import style0 from "./recordCard.vue?vue&type=style&index=0&id=16eabd96&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16eabd96",
  null
  
)

export default component.exports